var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConference = function SvgConference(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 21.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.6 17.1v3.5m0-3.5-4.5 3m4.5-3 4.5 3m-4.5-3v-2.5m8.5-14v11a3 3 0 0 1-3 3h-11a3 3 0 0 1-3-3V.6m17 0h1.5m-1.5 0h-17m0 0H.6m5.5 9.5 2.698-2.698a1 1 0 0 1 1.221-.15l1.162.696a1 1 0 0 0 1.221-.15L15.1 5.1"
  })));
};
export default SvgConference;